module.exports = __webpack_public_path__ + "static/media/logo-yo.81cb8532.svg";